import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import DataTable from '../../components/DataTable';

const ArtesList = () => {
  const [data, setData] = useState([]);
  useEffect(() => { api.get('/pesca/apetrechos').then(res => setData(res.data.data)); }, []);

  return (
    <DataTable 
      title="Artes de Pesca / Apetrechos"
      data={data}
      columns={[{ header: 'Nome da Arte / Equipamento', key: 'nome' }]}
    />
  );
};
export default ArtesList;